import React from 'react';
import {CommonCreate} from '../Common';
import {getInputs} from './Common';

export const MaterialFamilyCreate = props => (
  <CommonCreate
    {...{
      ...props,
      fields: getInputs(),
    }}
  />
);
